import { render } from "./HomeCongress.vue?vue&type=template&id=2fd6c3b6&scoped=true"
import script from "./HomeCongress.vue?vue&type=script&lang=js"
export * from "./HomeCongress.vue?vue&type=script&lang=js"

import "./HomeCongress.vue?vue&type=style&index=0&id=2fd6c3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd6c3b6"]])

export default __exports__